// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__19GNM","messages":"Chat_messages__2RpLs","dateDivider":"Chat_dateDivider__2BNP8"};